/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React from 'react';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import { Link } from '@bd/bdcore-named-routes';
import { SmoothLink, menuToggler } from '@bd/bdcore-utilities';
import { css, cx } from '@bd/bdui-styles/emotion';
import { colors } from '../styles';
import SitePlanModal from '../pages/CommunityDetail/Map';

const styles = css`
  width: 100%;
  background-color: #e2e2e2;
  padding: 15px 0;
  text-align: center;
  position:relative;
  z-index: 10;
  @media(min-width: 992px) {
    background-color: ${colors.brand2};
    margin-top: 0;
  }
  .menu-title {;
    width: auto;
    background-image: url(/images/icon-arrow-down.svg);
    background-repeat: no-repeat;
    background-position: 92% center;
    display: inline-block;
    padding-right: 30px;
    font-weight: bold;
    font-size: 14px;
    color: #18244D;
    letter-spacing: 2.88px;
    text-transform: uppercase;
  }
  ul {
    padding: 0;
    text-align: left;
    width: 300px;
    display: none;
    position: absolute;
    left: 50%;
    margin-left: -150px;
    top: 77px;
    list-style: none;
    background-color: ${colors.brand2};
    @media(min-width: 992px) {
      background-color: ${colors.brand2};
    }

    &.open {
      display: block;
    }
    li {
      border-bottom: 1px solid #CFCFCF;
      @media(min-width: 992px) {
        border-bottom: 0;
      }
      &:last-child {
        border-bottom: 0px;
      }
      a {
        background-color: ${colors.brand2};
        padding: 15px;
        display: block;
        font-weight: 800;
        font-size: 16px;
        color: ${colors.body} !important;
        transition: all .3s ease-out;
        @media(min-width: 992px) {
          background-color: ${colors.brand2};
        }
        &.active {
          background-color: ${colors.brand2Darkest};
          color: ${colors.white} !important;
        }

        &:hover {
          background-color: ${colors.brand2Darkest} !important;
          transition: all .3s ease-out;
          color: ${colors.white} !important;
        }
      }
    }
  }
  @media (min-width: 992px) {
    padding: 0;
    text-align: left;
    .menu-title {
      display: none;
    }
    ul {
      text-align: center;
      list-style: none;
      padding: 0 0 20px;;
      margin: 0;
      display: block;
      position: relative;
      width: auto;
      left: auto;
      margin-left: 0;
      top: auto;
      height: 70px;
      li {
        display: inline-block;
        margin: 0;
        a, .sitePlan_modal-styles {
          background-color: transparent;
          font-weight: 800;
          font-size: 14px !important;
          line-height: 70px;
          letter-spacing: 0.93px !important;
          text-align: center;
          text-transform: uppercase;
          padding: 0 15px;
          border: 0;
          position: relative;
          &.active {
          }
        }
      }
    }
  }
  .PageMenu_wrapper {
    @media(max-width: 992px){
      padding-top: 20px;
    }
  }
`;

function PageMenu({ className, title, items, match, activateMenu, isActiveMenu }) {
  return (
    <div className={cx(styles, className)}>
      <div className="DunhillContainer PageMenu_wrapper">
        <span className="menu-title" role="button" tabIndex="0" onClick={activateMenu('dropdown')}>{title}</span>
        <ul className={`page-menu ${isActiveMenu('dropdown') ? 'open' : ''}`}>
          {
            items.map(item => {
              if (item.hide) {
                return null;
              }
              if (item.modal) {
                return (
                  <li>
                    <span className="sitePlan_modal-styles">
                      <SitePlanModal key={item.title} >
                        {item.title}
                      </SitePlanModal>
                    </span>
                  </li>
                );
              }

              if (item.name) {
                return (
                  <li key={item.title}>
                    <Link
                      {...item}
                    >
                      {item.title}
                    </Link>
                  </li>
                );
              } else if (item.id) {
                return (
                  <li key={item.id}>
                    <SmoothLink
                      href={item.id}
                      tolerance={item.tolerance}
                    >
                      {item.title}
                    </SmoothLink>
                  </li>
                );
              }
              return (
                <li key={item.path}>
                  <a
                    href={item.path}
                    className={`${(match.path === item.path) || (match.path === '/portfolio/:gallery') ? 'active' : ''}`}
                  >
                    {item.title}
                  </a>
                </li>
              );
            })
          }
        </ul>
      </div>
    </div>
  );
}

PageMenu.propTypes = {
  className: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      path: PropTypes.string,
      name: PropTypes.string,
      id: PropTypes.string,
      title: PropTypes.string,
      params: PropTypes.object,
      keepParams: PropTypes.bool,
      tolerance: PropTypes.number,
    }),
  ),
  match: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  activateMenu: PropTypes.func.isRequired,
  isActiveMenu: PropTypes.func.isRequired,
};

PageMenu.defaultProps = {
  className: undefined,
  items: [],
  onSelect: undefined,
};

export default menuToggler(withRouter(PageMenu));



// WEBPACK FOOTER //
// ./src/components/PageMenu.js